import {
  imgJourney2001,
  imgJourney2017,
  imgJourney2011,
  imgJourney2015,
  imgJourney2018,
  imgJourney2019,
  imgJourney2020,
  imgJourney2021,
  logoMuri,
  logoTopBrand,
  logoPopularBrand,
  logoSocialMediaAward,
  logoDigitalBrand,
  logoBrandChoice,
} from "../assets/images";

// base tailwind
export const mediaQueries = {
  mobile: 640,
  tablet: 768,
  miniDesktop: 1024,
  desktop: 1280,
  largeDestop: 1536,
};

export const dataJourney = [
  {
    title: "Oxone Berdiri",
    year: "2001",
    desc: "Oxone berdiri di tahun 2001 dengan produk perdana yaitu timbangan badan.",
    img: imgJourney2001,
  },
  {
    title: "Menjadi Sponsor Kompetisi Memasak",
    year: "2011",
    desc: (
      <>
        Oxone menjadi sponsor alat dapur di program kompetisi memasak nomor satu
        di Indonesia, yaitu Masterchef Indonesia. <span className="block" />{" "}
        Diikuti dengan beberapa program memasak lainnya, seperti Masterchef
        Junior dan IronChef.
      </>
    ),
    img: imgJourney2011,
  },
  {
    title: "Oxone Battle Chef",
    year: "2015",
    desc: "Tidak hanya menyediakan alat rumah tangga Oxone juga mengadakan kompetisi memasak yang bertujuan untuk memotivasi para koki muda untuk terus mengembangkan bakatnya.",
    img: imgJourney2015,
  },
  {
    title: "Top Brand Awards",
    year: "2017",
    desc: "Oxone mendapatkan Top Brand Awards Pertama, Hingga saat ini dan awards dengan kategori terbanyak di tahun 2017.",
    img: imgJourney2017,
  },
  {
    title: "Chef Expo",
    year: "2018",
    desc: "Oxone mendukung asosiasi chef terbesar di Indonesia, ICA (Indonesia Chef Association), melalui event Chef Expo hingga sekarang.",
    img: imgJourney2018,
  },
  {
    title: "Oxone bersama ISDI dukung Down Syndome Indonesia",
    year: "2019",
    desc: (
      <>
        Bersama yayasan ISDI ( Ikatan Syndroma Down Indonesia ).
        <span className="block" />
        Oxone membantu teman-teman berkebutuhan khusus, dengan memberi kelas dan
        mentoring langsung berupa resep-resep yang dapat menjadi keahlian untuk
        teman-teman ISDI.
      </>
    ),
    img: imgJourney2019,
  },
  {
    title: "Rekor Muri",
    year: "2020",
    desc: (
      <>
        Oxone memecahkan Rekor Muri dengan catatan menara kue jahe tertinggi di
        Indonesia, tepat di bulan desember yang berlokasi di Oxone Store, Mall
        of Indonesia. <span className="block" />
        Pada tahun ini, Oxone juga membuka showroom di PIK Avenue Jakarta Utara.
      </>
    ),
    img: imgJourney2020,
  },
  {
    title: "Make Housework as Part of Your Lifestyle.",
    year: "2021",
    desc: "Kami akan terus berkembang dan memberikan yang terbaik bagi konsumen sebagai salah satu wujud komitmen kami kepada para konsumen. Integrasi dan mutu menjadi salah satu cermin dari pelayanan kami.",
    img: imgJourney2021,
  },
];

export const dataAwards = [
  {
    title: "Rekor Muri 2021",
    img: logoMuri,
    desc: "Sed tempus urna et pharetra pharetra massa massa. Mi bibendum neque egestas congue quisque egestas diam in.",
  },
  {
    title: "Top Brand Awards",
    img: logoTopBrand,
    desc: "Sed tempus urna et pharetra pharetra massa massa. Mi bibendum neque egestas congue quisque egestas diam in.",
  },
  {
    title: "Indonesia Popular Brand 2017",
    img: logoPopularBrand,
    desc: "Sed tempus urna et pharetra pharetra massa massa. Mi bibendum neque egestas congue quisque egestas diam in.",
  },
  {
    title: "Social Media Award 2017",
    img: logoSocialMediaAward,
    desc: "Sed tempus urna et pharetra pharetra massa massa. Mi bibendum neque egestas congue quisque egestas diam in.",
  },
  {
    title: "Indonesia Popular Brand 2022",
    img: logoDigitalBrand,
    desc: "Sed tempus urna et pharetra pharetra massa massa. Mi bibendum neque egestas congue quisque egestas diam in.",
  },
  {
    title: "Brand Choice Award 2022",
    img: logoBrandChoice,
    desc: "Sed tempus urna et pharetra pharetra massa massa. Mi bibendum neque egestas congue quisque egestas diam in.",
  },
];

export const dataMap = [
  // sumatera
  { title: "cityA", desc: "lorem ipsum", left: 8, top: 15 },
  { title: "cityB", desc: "lorem ipsum", left: 11, top: 28 },
  { title: "cityC", desc: "lorem ipsum", left: 17, top: 41 },
  { title: "cityD", desc: "lorem ipsum", left: 20, top: 61 },
  { title: "cityE", desc: "lorem ipsum", left: 20.5, top: 30 },
  { title: "cityF", desc: "lorem ipsum", left: 21, top: 50 },
  // kalimantan
  { title: "cityG", desc: "lorem ipsum", left: 32, top: 38 },
  { title: "cityH", desc: "lorem ipsum", left: 48, top: 33 },
  { title: "cityI", desc: "lorem ipsum", left: 46, top: 45 },
  { title: "cityJ", desc: "lorem ipsum", left: 45, top: 55 },
  // jawa
  { title: "cityK", desc: "lorem ipsum", left: 25, top: 72 },
  { title: "cityL", desc: "lorem ipsum", left: 28, top: 77 },
  { title: "cityM", desc: "lorem ipsum", left: 31, top: 79 },
  { title: "cityN", desc: "lorem ipsum", left: 35, top: 75 },
  { title: "cityO", desc: "lorem ipsum", left: 36, top: 81 },
  { title: "cityP", desc: "lorem ipsum", left: 41, top: 78 },
  { title: "cityQ", desc: "lorem ipsum", left: 46, top: 84 },
  // jawa
  { title: "cityR", desc: "lorem ipsum", left: 54, top: 64 },
  { title: "cityS", desc: "lorem ipsum", left: 63.8, top: 28 },
  { title: "cityT", desc: "lorem ipsum", left: 67, top: 46 },
  // papua
  { title: "cityU", desc: "lorem ipsum", left: 98, top: 55 },
];
